import {createReducer, on} from '@ngrx/store';
import {initialState} from './device-group.state';
import {DeviceGroupActions} from './device-group.actions';

export const deviceGroupReducer = createReducer(
  initialState,

  on(DeviceGroupActions.public.setDeviceGroupExpanded, (state, {id, isExpanded}) => ({
    ...state,
    expandedById: {
      ...state.expandedById,
      [id]: isExpanded,
    },
  })),

  on(DeviceGroupActions.public.updateDeviceGroupFilter, (state, {filter}) => ({
    ...state,
    filter,
  })),

  on(DeviceGroupActions.private.loadDeviceGroupsWithFilters, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(DeviceGroupActions.private.loadDeviceGroupsSuccess, (state, {deviceGroupsResponseDto}) => {
    const entities = {...state.entities};
    deviceGroupsResponseDto.deviceGroups.forEach((it) => {
      entities[it.id] = it;
    });

    return {
      ...state,
      entities,
      pages: {
        ...state.pages,
        [state.filter.page ?? 0]: deviceGroupsResponseDto.deviceGroups.map((it) => it.id),
      },
      totalCount: deviceGroupsResponseDto.totalCount,
      isLoading: false,
      error: null,
    };
  }),

  on(DeviceGroupActions.private.loadDeviceGroupsFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(DeviceGroupActions.private.loadDeviceGroupsWithProvidedFilters, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(DeviceGroupActions.private.loadDeviceGroupsWithProvidedFiltersSuccess, (state, {deviceGroupsResponseDto}) => {
    const entities = {...state.entities};
    deviceGroupsResponseDto.deviceGroups.forEach((it) => {
      entities[it.id] = it;
    });

    return {
      ...state,
      entities,
      isLoading: false,
      error: null,
    };
  }),

  on(DeviceGroupActions.private.loadDeviceGroupsWithProvidedFiltersFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(DeviceGroupActions.public.loadAllDeviceGroupsByFilters, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(DeviceGroupActions.private.loadAllDeviceGroupsByFiltersSuccess, (state) => ({
    ...state,
    isLoading: false,
    error: null,
  })),

  on(DeviceGroupActions.private.loadAllDeviceGroupsByFiltersFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(DeviceGroupActions.private.loadNextOfAll, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(DeviceGroupActions.private.loadNextOfAllSuccess, (state, {deviceGroupsResponseDto}) => {
    const entities = {...state.entities};
    deviceGroupsResponseDto.deviceGroups.forEach((it) => {
      entities[it.id] = it;
    });

    return {
      ...state,
      entities,
    };
  }),

  on(DeviceGroupActions.private.loadNextOfAllFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(DeviceGroupActions.public.triggerDeviceGroupAction, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(DeviceGroupActions.private.triggerDeviceGroupActionSuccess, (state, {responseDto}) => ({
    ...state,
    entities: {
      ...state.entities,
      [responseDto.deviceGroup.id]: responseDto.deviceGroup,
    },
    isLoading: false,
    error: null,
  })),

  on(DeviceGroupActions.private.triggerDeviceGroupActionFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(DeviceGroupActions.public.loadDeviceGroupById, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(DeviceGroupActions.private.loadDeviceGroupByIdSuccess, (state, {responseDto}) => ({
    ...state,
    entities: {
      ...state.entities,
      [responseDto.id]: responseDto,
    },
    isLoading: false,
    error: null,
  })),

  on(DeviceGroupActions.private.loadDeviceGroupByIdFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(DeviceGroupActions.public.createDeviceGroup, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(DeviceGroupActions.private.createDeviceGroupSuccess, (state, {responseDto}) => ({
    ...state,
    entities: {
      ...state.entities,
      [responseDto.id]: responseDto,
    },
    isLoading: false,
    error: null,
  })),

  on(DeviceGroupActions.private.createDeviceGroupFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(DeviceGroupActions.public.updateDeviceGroup, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(DeviceGroupActions.private.updateDeviceGroupSuccess, (state, {responseDto}) => ({
    ...state,
    entities: {
      ...state.entities,
      [responseDto.id]: responseDto,
    },
    isLoading: false,
    error: null,
  })),

  on(DeviceGroupActions.private.updateDeviceGroupFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error,
  })),

  on(DeviceGroupActions.public.deleteDeviceGroupById, (state) => ({
    ...state,
    isLoading: true,
    error: null,
  })),

  on(DeviceGroupActions.private.deleteDeviceGroupSuccess, (state, {id}) => {
    const entities = {...state.entities};
    delete entities[id];
    const expandedById = {...state.expandedById};
    delete expandedById[id];

    const pages = Object.fromEntries(
      Object.entries(state.pages).map(([page, ids]) => [page, ids.filter((it) => it !== id)]),
    );

    return {
      ...state,
      entities,
      expandedById,
      pages,
      totalCount: Math.max(0, state.totalCount - 1),
      isLoading: false,
      error: null,
    };
  }),

  on(DeviceGroupActions.private.deleteDeviceGroupFailure, (state, {error}) => ({
    ...state,
    isLoading: false,
    error,
  })),
);
